module.exports = __webpack_public_path__ + "img/hen.0e067164.png";